// import {
//   TopBar,
//   HeroSection,
//   SiteCardSection,
//   AboutSection,
//   FooterBar,
// } from "./components";

import {
  CardSection,
  TestimonialSlider,
  SectionDivider,
  GetStartedSection,
} from "./componentsV2";
import { Box } from "@mui/material";
import { NavBar } from "./navbar";
import { ContactUsSection } from "./contact";
import { HeroSectionShorter, HeroSection } from "./homehero";

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function Home() {
  useEffect(() => {
    document.title = "Welcome";
  }, []);

  const location = useLocation();

  useEffect(() => {
    const id = location.state?.scrollToId;
    if (id) {
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [location]);

  return (
    // <Box sx={{ margin: 0, padding: 0 }}>
    //   <TopBar />
    //   <HeroSection />
    //   <SiteCardSection />
    //   <AboutSection />
    //   <FooterBar />
    // </Box>
    <Box sx={{ margin: 0, padding: 0 }}>
      <NavBar />
      {/* <HeroSection /> */}
      <HeroSectionShorter />
      <CardSection />
      {/* <TestimonialSlider /> */}
      <SectionDivider />
      <GetStartedSection />
      <ContactUsSection />
    </Box>
  );
}
